<template>
  <div>
    <div class="input-number-range" :class="{ 'is-range-disabled': disabled, 'is-border-color': isChilFocus}">
      <div class="flex">
        <div class="left">
          <el-input size="small" ref="input_from" v-model="userInputForm" :disabled="disabled" placeholder="最小值"
            @blur="handleBlurFrom" @focus="handleFocusFrom" @change="handleInputChangeFrom" clearable>
          </el-input>
        </div>
        <div class="center">
          <span>至</span>
        </div>
        <div class="to">
          <el-input size="small" ref="input_to" v-model="userInputTo" :disabled="disabled" placeholder="最大值" @blur="handleBlurTo"
            @focus="handleFocusTo" @change="handleInputChangeTo" clearable></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'inputRange',

    props: {
      // 初始化范围
      value: [],

      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },

      // 精度参数
      precision: {
        type: Number,
        default: 0,
        validator(val) {
          return val >= 0 && val === parseInt(val, 10)
        }
      }
    },

    data() {
      return {
        userInputForm: null,
        userInputTo: null,
        isChilFocus: false
      }
    },

    watch: {
      value: {
        handler(value) {
          /** 初始化范围 */
          if (value instanceof Array) {
            this.userInputForm = typeof value[0] === 'number' ? value[0] : null
            this.userInputTo = typeof value[1] === 'number' ? value[1] : null
          } else {
            this.userInputForm = "";
            this.userInputTo = "";
          }
        },
        deep: true,
        immediate: true
      }
    },

    mounted() {

    },

    methods: {
      // 根据精度保留数字
      toPrecision(num, precision) {
        if (precision === undefined) precision = 0
        return parseFloat(
          Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)
        )
      },

      handleBlurFrom(event) {
        this.isChilFocus = false;
        // this.$emit('blurfrom', event)
      },

      handleFocusFrom(event) {
        this.isChilFocus = true;
        // this.$emit('focusfrom', event)
      },

      handleBlurTo(event) {
        this.isChilFocus = false;
        // this.$emit('blurto', event)
      },

      handleFocusTo(event) {
        this.isChilFocus = true;
        // this.$emit('focusto', event)
      },

      // from输入框change事件
      handleInputChangeFrom(value) {
        console.log(value,"----");
        // 如果是非数字空返回null
        if (isNaN(value) || value === '') {
          //   this.$emit('input', [null, this.userInputTo])
          //   this.$emit('changefrom', this.userInputForm)
          this.userInputForm = ''
          this.$emit('input', [this.userInputForm, this.userInputTo])
          this.$emit('changeRange', [this.userInputForm, this.userInputTo])
          return
        }

        // 初始化数字精度
        this.userInputForm = this.setPrecisionValue(value)

        // 如果from > to 将from值替换成to
        if (typeof this.userInputTo === 'number') {
          this.userInputForm =
            parseFloat(this.userInputForm) <= parseFloat(this.userInputTo) ?
            this.userInputForm :
            this.userInputTo
        }
        if (this.userInputTo != null || this.userInputTo != '') {
          this.$emit('input', [this.userInputForm, this.userInputTo])
          this.$emit('changeRange', [this.userInputForm, this.userInputTo])
        }
      },

      // to输入框change事件
      handleInputChangeTo(value) {
        // 如果是非数字空返回null
        if (isNaN(value) || value === '') {
          // //   this.$emit('input', [this.userInputForm, null])
          // //   this.$emit('changefrom', this.userInputTo)
          // return
          this.userInputTo = ''
          this.$emit('input', [this.userInputForm, this.userInputTo])
          this.$emit('changeRange', [this.userInputForm, this.userInputTo])
          return
        }

        // 初始化数字精度
        this.userInputTo = this.setPrecisionValue(value)

        // 如果to < tfrom 将to值替换成from
        if (typeof this.userInputForm === 'number') {
          this.userInputTo =
            parseFloat(this.userInputTo) >= parseFloat(this.userInputForm) ?
            this.userInputTo :
            this.userInputForm
        }
        if (this.userInputForm != null || this.userInputForm != '') {
          this.$emit('input', [this.userInputForm, this.userInputTo])
          this.$emit('changeRange', [this.userInputForm, this.userInputTo])
        }
      },

      // 设置成精度数字
      setPrecisionValue(value) {
        if (this.precision !== undefined) {
          const val = this.toPrecision(value, this.precision)
          return val
        }
        return null
      }
    }
  }

</script>
<style lang="scss" scoped>
  // 取消element原有的input框样式

  .input-number-range {
    background-color: #fff;
    border: 1px solid #DEDEDE;
    border-radius: 4px;
    height: 30px;

    /deep/ .el-input__inner {
      border: 0px;
      margin: 0;
      padding: 0 15px;
      background-color: transparent !important;
    }


    .flex {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: center;
      align-items: center;
    }
  }

  .input-number-range:hover {
    border-color: #E3E3E3;
  }

  .is-border-color {
    border-color: #E3E3E3;
  }

  .is-range-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }

</style>



// WEBPACK FOOTER //
// src/components/inputRange/inputRange.vue